// src/app/layout/CoreNavList.tsx
import { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { CORE_NAV_ITEMS } from './core-nav-items';

interface CoreNavListProps {
  /** Called after a nav item is clicked — used by CoreMobileNavDrawer to close itself. */
  onItemSelect?: () => void;
}

// Single rendering path for CORE_NAV_ITEMS — consumed by both
// CoreSidebar (desktop) and CoreMobileNavDrawer (< lg), so there is
// exactly one place that walks the array, groups by section, and
// applies active styling. CORE_NAV_ITEMS in ./core-nav-items.ts
// remains the only source of menu data — nothing here is hardcoded.
export function CoreNavList({ onItemSelect }: CoreNavListProps) {
  return (
    <nav className="vania-shell-nav">
      {CORE_NAV_ITEMS.map((item) => {
        const Icon = item.icon;

        return (
          <Fragment key={item.to}>
            <NavLink
              to={item.to}
              onClick={onItemSelect}
              className={({ isActive }) =>
                [
                  'vania-shell-nav-item',
                  isActive
                    ? 'is-active'
                    : '',
                ].join(' ')
              }
            >
              <Icon size={17} strokeWidth={2.2} />
              {item.label}
            </NavLink>
          </Fragment>
        );
      })}
    </nav>
  );
}
